var a={name:"rzIconSpeechTail"};export{a as default};
